module.exports = __webpack_public_path__ + "static/media/BlueSquareInfoIcon.02ae58fd.svg";